import Button from '@mui/material/Button';
import { red } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import WarningIcon from '@mui/icons-material/Warning';
import Link from 'next/link';

const redTheme = createTheme({
  palette: {
    primary: red,
  },
});

export default function DeleteAccountBtn() {
  return (
    <ThemeProvider theme={redTheme}>
      <Link href="/about/contact?accountdeletion=true">
        <Button variant="outlined" className="mt-3">
          <WarningIcon /> <span className="pl-2">Delete Account</span>
        </Button>
      </Link>
    </ThemeProvider>
  );
}
